import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Router, Route } from "react-router-dom";

import { getStore } from "./store/configureStore";
import { getHistory } from './util/configureHistory';

import * as settings from "./actions/settingActions";
import * as layout from "./actions/layoutActions";

import * as reference from "./actions/referentieActions";

import * as adressen from "./actions/adresGatewayActions";

import "../css/site.css";
import "../node_modules/toastr/build/toastr.min.css";

import App from "../js/components/App";

const store = getStore();
const history = getHistory();
const settingsPromise = store.dispatch(settings.loadSettings());
const layoutPromise = store.dispatch(layout.loadDefaultLayout());
const referencePromise = store.dispatch(reference.loadReferences());
const adressenPromise = store.dispatch(adressen.loadGemeenten());

Promise.all([settingsPromise, layoutPromise, referencePromise, adressenPromise])
    .then(() => {
        render(
			<Provider store={store}>
			<Router history={history}>
				<Route path={store.getState().settings.siteRoot} component={App} />
			</Router >
		</Provider>, document.getElementById('app')
        );
    });
